import React from 'react'
import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { ManageExpenses } from './recurringsettings/ManageExpenses'
import { ManageIncome } from './recurringsettings/ManageIncome'

import { useEvent, useGlobalCopyStore } from '../../../common'

interface RecurringSettingsProps {
  defaultSelectedTab?: number
}

export const RecurringSettings = observer(({ defaultSelectedTab = 0 }: RecurringSettingsProps) => {
  const [selectedTab, setSelectedTab] = React.useState(defaultSelectedTab)
  const { onEvent } = useEvent()
  const { recurring: recurringCopy } = useGlobalCopyStore()

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue)
    onEvent(
      newValue === 0
        ? 'recurring_transactions_widget_manage_expenses'
        : 'recurring_transactions_widget_edit_income',
    )
  }

  return (
    <Box bgcolor="background.default" height="100%">
      <Tabs
        onChange={handleTabChange}
        sx={{ bgcolor: 'background.paper', mb: 0 }}
        value={selectedTab}
        variant="fullWidth"
      >
        <Tab label={recurringCopy.expenses} />
        <Tab label={recurringCopy.income} />
      </Tabs>
      {selectedTab === 0 && <ManageExpenses />}
      {selectedTab === 1 && <ManageIncome />}
    </Box>
  )
})
